import React, {useEffect, useState} from 'react';
import './MarchBanner.css';
import {DatePicker, Typography} from 'antd';
import {useOrders} from "../../api/useOrders";

// Типы и интерфейсы
type OrderStep = 'bouquet' | 'details' | 'payment';
const { Text } = Typography;

interface FormData {
    // Шаг 1: Выбор букета
    bouquetType: string[];
    priceRange: string[];

    // Шаг 2: Детали заказа
   
    name: string;
    phone: string;
    isDelivery: boolean;
    date: string;
    recipientName: string;
    recipientPhone: string;
    address: string;
    cardMessage: string;
    communicationMethod: string;
}

interface PriceRange {
    id: string;
    label: string;
    min: number;
    max: number;
    icon: string;
}

interface BouquetCategory {
    id: string;
    name: string;
    description: string;
    image: string;
}

const createFormData = () => ({
    bouquetType: [],
    priceRange: [],
    recipientName: '',
    name: '',
    phone: '',
    recipientPhone: '',
    isDelivery: false,
    date: '',
    address: '',
    cardMessage: '',
    communicationMethod: ''
})

export const MarchBanner: React.FC = () => {
    const [currentStep, setCurrentStep] = useState<OrderStep>('bouquet');
    const [formData, setFormData] = useState<FormData>(createFormData());

    const [submitStatus, setSubmitStatus] = useState<'success' | 'error' | null>(null);
    const {loading, error, createOrder } = useOrders();

    // Ценовые диапазоны
    const priceRanges: PriceRange[] = [
        { id: 'Эконом', label: 'Эконом', min: 500, max: 2000, icon: '🌱' },
        { id: 'Стандарт', label: 'Стандарт', min: 2000, max: 4000, icon: '🌸' },
        { id: 'Премиум', label: 'Премиум', min: 4000, max: 6000, icon: '🌹' },
        { id: 'Luxury', label: 'Luxury', min: 6000, max: 10000, icon: '👑' },
        { id: 'vip', label: 'VIP', min: 10000, max: 50000, icon: '💎' }
    ];

    // Категории букетов
    const bouquetCategories: BouquetCategory[] = [
        {
            id: 'Тюльпаны',
            name: 'Тюльпаны',
            description: 'Яркие, свежие и нежные',
            image: '🌷'
        },
        {
            id: 'Розы',
            name: 'Розы',
            description: 'Изысканные и запоминающиеся',
            image: '🌹'
        },
        {
            id: 'Лилии',
            name: 'Лилии',
            description: 'Стойкие с благородным ароматом',
            image: '🌺'
        },
        {
            id: 'Диантусы',
            name: 'Диантусы',
            description: 'Естественные и нежные',
            image: '🌸'
        },
        {
            id: 'Хризантемы',
            name: 'Хризантемы',
            description: 'Пышные и солнечные',
            image: '🌼'
        }
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        if (name.includes("hone") && value.length && !/[0-9]/.test(value)) return;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDateChange = (_: any, dateString: string | null) => {
        setFormData(prev => ({
            ...prev,
            date: dateString || "",
        }));
    };

    const handleDeliveryMethodChange = (method: boolean) => {
        setFormData(prev => ({
            ...prev,
            isDelivery: method,
        }));
    };

    const selectBouquetType = (type: string) => {
        setFormData(prev => {
            if (prev.bouquetType.includes(type)) {
                return {...prev, bouquetType: prev.bouquetType.filter(i => i !== type)};
            } else {
                return {...prev, bouquetType: [...prev.bouquetType, type]}
            }
        })
    }

    const selectPrice = (type: string) => {
        setFormData(prev => {
            if (prev.priceRange.includes(type)) {
                return {...prev, priceRange: prev.priceRange.filter(i => i !== type)};
            } else {
                return {...prev, priceRange: [...prev.priceRange, type]}
            }
        })
    }

    const handleSubmit = async () => {
        try {
            await createOrder(formData);

            setSubmitStatus('success');
            setFormData(createFormData());
            setCurrentStep('bouquet');
        } catch ({message}) {
            console.log('123' + message);
            setSubmitStatus("error");
        }
    };

    const nextStep = () => {
        if (currentStep === 'bouquet') {
            setCurrentStep('details');
        } else if (currentStep === 'details' && formData.phone && formData.date) {
          handleSubmit()
        }
    };

    const prevStep = () => {
        if (currentStep === 'details') setCurrentStep('bouquet');
        if (currentStep === 'payment') setCurrentStep('details');
    };

    const getStepProgress = () => {
        const steps = ['bouquet', 'details'];
        return (steps.indexOf(currentStep) / (steps.length - 1)) * 100;
    };

    return (
        <section className="order-container">
                {/* Заголовок с прогрессом */}
                <div className="order-header">
                    <h2 className="order-title">
                        <span className="title-highlight">Букеты на заказ</span>
                        <span className="title-sub">Подарите радость и эмоции близким</span>
                    </h2>

                    <div className="order-progress">
                        <div className="progress-steps">
                            <div className={`progress-step ${currentStep === 'bouquet' ? 'active' : ''} ${currentStep !== 'bouquet' ? 'completed' : ''}`}>
                                <span className="step-number">1</span>
                                <span className="step-label">Выбор букета</span>
                            </div>
                            <div className={`progress-step ${currentStep === 'details' ? 'active' : ''} ${currentStep === 'payment' ? 'completed' : ''}`}>
                                <span className="step-number">2</span>
                                <span className="step-label">Детали</span>
                            </div>
                        </div>
                        <div className="progress-bar">
                            <div className="progress-fill" style={{ width: `${getStepProgress()}%` }}></div>
                        </div>
                    </div>
                </div>

                {/* Уведомления */}
                {submitStatus === 'success' && (
                    <div className="notification success">
                        <div className="notification-icon">✓</div>
                        <div className="notification-content">
                            <strong>Заказ успешно оформлен!</strong>
                        </div>
                    </div>
                )}

                {submitStatus === 'error' && (
                    <div className="notification error">
                        <div className="notification-icon">✕</div>
                        <div className="notification-content">
                            <strong>Ошибка оформления</strong>
                            <p>Пожалуйста, попробуйте снова или свяжитесь с нами по телефону</p>
                        </div>
                    </div>
                )}

                {/* Форма заказа */}
                <form onSubmit={handleSubmit} className="order-form">
                    {/* Шаг 1: Выбор букета */}
                    {currentStep === 'bouquet' && (
                        <div className="form-step step-bouquet">
                            <h2 className="step-title">Выберите букет</h2>

                            <div className="bouquet-categories">
                                {bouquetCategories.map(category => (
                                    <div
                                        key={category.id}
                                        className={`bouquet-card ${formData.bouquetType.includes(category.id) ? 'selected' : ''}`}
                                        onClick={() => selectBouquetType(category.id)}
                                    >
                                        <span className="bouquet-emoji">{category.image}</span>
                                        <h3 className="bouquet-name">{category.name}</h3>
                                        <p className="bouquet-description">{category.description}</p>
                                    </div>
                                ))}
                            </div>

                            <h2 className="step-title">Ценовой диапазон</h2>
                            <div className="price-ranges">
                                {priceRanges.map(range => {
                                    return (
                                        <div
                                            key={range.id}
                                            className={`price-card ${formData.priceRange.includes(range.id) ? 'selected' : ''}`}
                                            onClick={() => selectPrice(range.id)}
                                        >
                                            <span className="price-icon">{range.icon}</span>
                                            <div className="price-info">
                                                <span className="price-label">{range.label}</span>
                                                <span className="price-value">{range.min} - {range.max} ₽</span>
                                            </div>
                                            {formData.priceRange.includes(range.id) && (
                                                <span className="selected-check">✓</span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Шаг 2: Детали заказа */}
                    {currentStep === 'details' && (
                        <div className="form-step step-details">
                            <h2 className="step-title">Детали заказа</h2>

                            <div className="form-grid">
                                <div className="form-group">
                                    <label htmlFor="name">Ваше имя</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Ваше имя"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="phone">Телефон для связи</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        placeholder="8 (999) 999-99-99"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="date">Дата</label>
                                    <DatePicker
                                        id="date"
                                        name="date"
                                        placeholder="Выберите дату"
                                        required
                                        style={{borderColor: "#e8e8e8"}}
                                        className="form-group__input" format="DD-MM-YYYY"
                                        disabledDate={d => !d || d.isBefore(Date.now()-86400000)}
                                        onChange={handleDateChange}
                                    />
                                </div>
                            </div>

                            <div className="delivery-methods">
                                <div className="delivery-toggle">
                                    <button
                                        type="button"
                                        className={`delivery-option ${formData.isDelivery ? '' : 'active'}`}
                                        onClick={() => handleDeliveryMethodChange(false)}
                                    >
                                        <span className="option-icon">📍</span>
                                        <span className="option-label">Самовывоз</span>
                                        <span className="option-price">Бесплатно</span>
                                    </button>
                                    <button
                                        type="button"
                                        className={`delivery-option ${formData.isDelivery ? 'active' : ''}`}
                                        onClick={() => handleDeliveryMethodChange(true)}
                                    >
                                        <span className="option-icon">🚚</span>
                                        <span className="option-label">Доставка</span>
                                        <span className="option-price"></span>
                                    </button>
                                    <div></div>
                                    <Text type="secondary" className="contacts__text">Стоимость доставки мы рассчитываем персонально — в зависимости от удаленности и тарифов службы доставки</Text>
                                </div>


                                <div className="delivery-details">
                                    {formData.isDelivery && (
                                        <>
                                        <div className="form-group">
                                            <label htmlFor="recipientName">Имя получателя</label>
                                            <input
                                                type="text"
                                                id="recipientName"
                                                name="recipientName"
                                                value={formData.recipientName}
                                                onChange={handleChange}
                                                required
                                                placeholder="Имя получателя"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="recipientPhone">Телефон получателя</label>
                                            <input
                                                type="tel"
                                                id="phone"
                                                name="recipientPhone"
                                                value={formData.recipientPhone}
                                                onChange={handleChange}
                                                required
                                                placeholder="8 (999) 999-99-99"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="address">Адрес доставки</label>
                                            <textarea
                                                id="address"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                required={formData.isDelivery}
                                                rows={2}
                                                placeholder="Улица, дом, квартира, подъезд, этаж"
                                            />
                                        </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="cardMessage">Текст открытки</label>
                                <textarea
                                    id="cardMessage"
                                    name="cardMessage"
                                    value={formData.cardMessage}
                                    onChange={handleChange}
                                    rows={3}
                                    placeholder="Напишите пожелания для получателя"
                                />
                            </div>
                        </div>
                    )}

                    {/* Навигационные кнопки */}
                    <div className="form-navigation">
                        {currentStep !== 'bouquet' && (
                            <button type="button" className="nav-btn prev" onClick={prevStep}>
                                ← Назад
                            </button>
                        )}
                        <button
                            type="button"
                            className="nav-btn next"
                            onClick={nextStep}
                            disabled={currentStep === 'details' && (!formData.phone || !formData.date)}
                        >
                            Продолжить →
                        </button>
                    </div>
                </form>

                {/* Дополнительная информация */}
                <div className="order-info">
                    <div className="info-card">
                        <span className="info-icon">🌷</span>
                        <h4>Свежесть гарантируем</h4>
                        <p>Только свежие цветы от проверенных поставщиков</p>
                    </div>
                    <div className="info-card">
                        <span className="info-icon">🎁</span>
                        <h4>Открытка в подарок</h4>
                        <p>При оформлении заказа через сайт</p>
                    </div>
                    <div className="info-card">
                        <span className="info-icon">⏰</span>
                        <h4>Курьерская доставка</h4>
                        <p>Доставим к указанному часу</p>
                    </div>
                </div>
            </section>
    );
};